<template>
  <div class="base_color">
    <div id="container">

      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause">
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          上海浦东发展银行个人开户申请书
        </p>
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          开户须知（2022年8月版）
        </p>
        <p class="distance_50">
          一、本须知适用于申请人（或其合法监护人，下同）在上海浦东发展银行（以下简称“浦发银行”）开立各类存折、存单和借记卡业务。
        </p>
        <p class="distance_50">
          二、申请人自愿在浦发银行开立个人银行账户。申请人须遵守国家法律法规、监管机构规定及与浦发银行就开立个人账户签署相关协议的有关约定。
        </p>
        <p class="distance_50">
          三、申请人充分了解并清楚知晓出租、出借、出售、转让、冒用、冒领、购买等使用非本人账户的相关法律责任和浦发银行根据法律法规、监管机构规定和申请人已签署有关协议的约定采取相关措施，承诺依法依规开立和使用本人账户。
        </p>
        <p class="distance_50">
          四、申请人开立个人银行账户时须保证向浦发银行提供符合《个人存款账户实名制规定》（中华人民共和国国务院令第285号）及其他相关规定的所需资料，并保证据实、完整、合法地填写开户申请书及其他相关资料。如委托他人代为开立个人银行账户，则委托人须保证应当遵守前述约定，同时还须保证账户申请人同意和遵守申请书和开户须知的约定。申请人申请开立账户遵照有关法律法规和监管机构关于个人银行结算账户分类、使用、管理等规定。
        </p>
        <p class="distance_50">
          五、申请人同意浦发银行以浦发银行公告的收费内容和收费标准对个人账户的管理或其他服务收取费用。
        </p>
        <p class="distance_50">
          六、申请人于开户时预留的个人信息或资料发生变动时，应及时通知浦发银行进行修改，因申请人未及时通知浦发银行，造成业务不能如期办理及其他后果的，申请人自行承担相关责任。
        </p>
        <p class="distance_50">
          七、申请人同意借记卡、活期一本通的人民币活期账户自动设置为个人结算账户，当有外币资金入账时，借记卡、活期一本通将自动开立相应外币活期储蓄账户。申请人保证其对个人结算账户以及外币活期储蓄账户的使用遵守中国人民银行、国家外汇管理局等金融监管机构有关账户管理的规定，并定期与浦发银行核对账务。
        </p>
        <p class="distance_50">
          八、借记卡、各类存折、存单遗失、被盗或密码遗忘、泄露的，申请人应及时向浦发银行申请挂失，申请人在申请挂失（含口头挂失）前账户资金被支取，由申请人自行承担相关责任。
        </p>
        <p class="distance_50">
          九、申请人在银行进行余额查询、打印时，所显示的余额可能包含申请人因使用P0S消费等行为已经发生支付的金额（因商户结算周期等原因，消费金额尚未被扣除）。
        </p>
        <p class="distance_50">
          十、申请人应妥善保管账号、密码等资料，不得将本人账户转借给他人使用。因申请人本人资料泄露或将本人账户转借他人使用产生的风险，损失及其他后果均由申请人自行承担。
        </p>
        <p class="distance_50">
          十一、浦发银行仅通过我行特别号码95528、106980095528、106905695528、1069402595528、1069270395528、106913595528、106934095528、1069116095528、1069039095528向客户发送所有短信通知和其他信息，申请人务必注意识别，以防范虚假短信。浦发银行将通过官方网站（www.spdb.com.cn）及时公示号码变更情况，请申请人关注。
        </p>
        <p class="distance_50">
          十二、因通讯异常及其他不可抗力因素或申请人原因造成的风险和损失，浦发银行不承担责任。
        </p>
        <p class="distance_50">
          十三、在申请人开立于浦发银行的任何账户的存续期间，若违反浦发银行反洗钱管理规定、或浦发银行具备合理理由怀疑申请人及其业务涉嫌参与联合国安理会、反洗钱金融行动特别工作组、中国、美国、欧盟、英国、新加坡等国际组织或国家认定的洗钱、制裁、恐怖融资、大规模杀伤性武器扩散融资活动、逃税、出口管制等违法违规行为的，浦发银行有权按照中国人民银行反洗钱监管规定等规定及内部管理规定，对申请人全部或部分账户采取中止服务和／或销户等必要的管控措施，且不承担任何责任。
        </p>
        <p class="distance_50">
          十四、申请人通过开立于浦发银行的任何账户所办理的业务，如涉嫌参与前述洗钱、恐怖融资或扩散（大规模杀伤性武器）融资等活动，导致浦发银行向申请人提供服务时遭受损失的，申请人应向浦发银行承担赔偿责任。赔偿责任的范围包括但不限于浦发银行由于申请人的活动被境内外司法机关裁判承担的损失，境内外政府机构或监管机关对于浦发银行为申请人的活动提供服务所进行的处罚以及浦发银行为应对上述情形采取措施所产生的一切费用和损失等。
        </p>
        <p class="distance_50">
          十五、申请人已完全知悉并接受浦发银行借记卡章程及领用协议的全部内容，并保证遵守浦发银行借记卡章程及领用协议的约定。
        </p>
        <p class="distance_50">
          十六、申请人同意借记卡、定期一本通、定期存单中的整存整取定期存款到期后由本行代为自动转存。
        </p>
        <p class="distance_50">
          十七、申请人所持借记卡每日在ATM机上提款的最高限额和次数按监管机构的规定执行。
        </p>
        <p class="distance_50">
          十八、说明：①中国内地税收居民的定义请见国家税务总局网站(http://www.chinatax.gov.cn/aeoi_index.html）的相关定义。②非居民是指中国内地税收居民以外的个人。其他国家（地区）税收居民身份认定规则及纳税人识别号相关信息请参见国家税务总局网站(http://www.chinatax.gov.cn/aeoi_index.html)。③居住地址是指账户持有人税收居民国（地区）的地址，不是中国代理人的地址，也不是在中国临时居住的地址。④税收居民国（地区）为美国的，必须填报纳税人识别号。美国个人是指具有美国国籍，持有美国绿卡或者在美国长期停留的个人。在美国长期停留是指：当年在美国停留31天以上，并在3年内累计超过183天。累计方式是当年每一天算一天，去年每一天算1/3天，前一年每一天算1/6天。⑤军人、武装警察无需填写税收居民身份声明文件。
        </p>
        <p class="distance_50">
          十九、在浦发银行为申请人提供产品或服务所必需的情形下，申请人自愿同意并授权浦发银行在符合法律法规及监管机构规定的前提下采集、传输、处理、保存申请人的姓名、证件号码、银行卡号、手机号等相关个人信息，主要用于为申请人提供开立各类存折、存单和借记卡等产品或服务，以及保障申请人账户及交易的安全。我行将按照法律法规和监管规定采取措施，保障申请人的个人信息安全。
        </p>
        <p class="distance_50">
          二十、鉴于国家有权机关关于开展非居民金融账户涉税信息尽职调查的要求，规范金融机构对非居民金融账户涉税信息的尽职调查行为，浦发银行需开展非居民金融账户涉税信息尽职调查的工作，识别非居民金融账户，收集并报送账户相关信息。浦发银行承诺对收集的相关信息承担保密义务，信息保存期限按照监管要求执行。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pufaAccountAgreement',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 24px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
.table{
  margin: 20px 10px;
}
</style>
